import styled, { css } from 'styled-components';
import { Label } from '../../../components/uielements';
import { palette } from 'styled-theme';

export const Main = styled.main`
  display: flex;
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;
`;

export const SectionLeft = styled.section`
  background-color: ${palette('background', 0)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
  padding: ${(props) => (props.isCollapsed ? '20px 10px' : '120px')};
  width: ${(props) => (props.isCollapsed ? '80px' : '50vw')};
  min-width: ${(props) => (props.isCollapsed ? '80px' : '400px')};
  max-width: ${(props) => (props.isCollapsed ? '80px' : '50vw')};
  position: relative;
  transition: all 0.4s ease-in-out;
  overflow: hidden;
  z-index: 10;
  box-shadow: ${(props) =>
    props.isCollapsed ? '2px 0 8px rgba(0, 0, 0, 0.1)' : '4px 0 20px rgba(0, 0, 0, 0.15)'};

  @media (max-width: 768px) {
    width: ${(props) => (props.isCollapsed ? '60px' : '85vw')};
    min-width: ${(props) => (props.isCollapsed ? '60px' : '300px')};
    max-width: ${(props) => (props.isCollapsed ? '60px' : '85vw')};
    padding: ${(props) => (props.isCollapsed ? '20px 5px' : '60px 20px')};
  }
`;

export const SectionRight = styled.section`
  background-size: cover;
  background-position: center;
  flex: 1;
  position: relative;
  transition: all 0.4s ease-in-out;
  width: ${(props) => (props.isCollapsed ? 'calc(100vw - 80px)' : '50vw')};

  @media (max-width: 768px) {
    width: ${(props) => (props.isCollapsed ? 'calc(100vw - 60px)' : '15vw')};
  }
`;

export const SliderToggle = styled.button`
  position: absolute;
  top: 50%;
  right: ${(props) => (props.isCollapsed ? '15px' : '20px')};
  transform: translateY(-50%);
  width: 50px;
  height: 80px;
  background: linear-gradient(90deg, #7b5cff, #60a5fa);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 123, 255, 0.3);
  transition: all 0.4s ease-in-out;
  z-index: 1001;

  &:hover {
    background: linear-gradient(90deg, #7b5cff, #60a5fa);
    box-shadow: 0 4px 15px rgba(0, 123, 255, 0.5);
    transform: translateY(-50%) scale(1.05);
  }

  &:focus {
    outline: 3px solid #007bff;
    outline-offset: 2px;
  }

  &:active {
    transform: translateY(-50%) scale(0.95);
  }

  svg {
    transition: transform 0.2s ease-in-out;
  }

  @media (max-width: 768px) {
    top: 30px;
    right: ${(props) => (props.isCollapsed ? '10px' : '15px')};
    transform: translateY(0);
    width: 40px;
    height: 40px;
    border-radius: 50%;

    &:hover {
      transform: translateY(0) scale(1.05);
    }

    &:active {
      transform: translateY(0) scale(0.95);
    }
  }
`;

export const PanelContent = styled.div`
  opacity: ${(props) => (props.isCollapsed ? '0' : '1')};
  transform: translateX(${(props) => (props.isCollapsed ? '-30px' : '0')});
  transition: all 0.4s ease-in-out;
  transition-delay: ${(props) => (props.isCollapsed ? '0s' : '0.2s')};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
  pointer-events: ${(props) => (props.isCollapsed ? 'none' : 'auto')};
  visibility: ${(props) => (props.isCollapsed ? 'hidden' : 'visible')};
`;

export const Heading = styled(Label).attrs({ size: 'header2', color: 'black', weight: 'bold' })`
  text-transform: uppercase;
`;

export const SubHeading = styled(Label).attrs({ size: 'normal', color: 'black' })``;

export const InfoButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-family: 'JetBrains Mono Regular';
  max-width: fit-content;
  & span {
    display: block;
    text-align: left;
    white-space: normal;
    word-break: break-word;
  }
`;

export const ModalHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;

  h3 {
    margin: 0;
    font-size: 1.5rem;
    color: #333;
  }
`;

export const ModalBody = styled.div`
  padding: 16px;
  max-height: 80vh;
  overflow-y: auto;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    color: red;
  }

  &:focus {
    outline: 2px solid #005fcc;
    outline-offset: 2px;
  }

  &:focus-visible {
    outline: 2px solid #005fcc;
    outline-offset: 2px;
  }
`;

export const ImageContainer = styled.div`
  margin: 16px 0;
  text-align: center;
`;

export const StyledImage = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:focus {
    outline: 2px solid #005fcc;
    outline-offset: 4px;
  }
`;

export const ContentWrapper = styled.div`
  p {
    margin: 12px 0;
    line-height: 1.5;
    color: #333;
  }

  .text-link {
    background: none;
    border: none;
    color: #005fcc;
    padding: 0;
    font: inherit;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 3px;

    &:hover {
      color: #003d80;
    }

    &:focus {
      outline: 2px solid #005fcc;
      outline-offset: 2px;
    }

    &:focus:not(:focus-visible) {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid #005fcc;
      outline-offset: 2px;
    }
  }
`;

export const ButtonWapper = styled.div`
  display: flex;
  gap: 10px;
`;

export const CaptureButton = styled.button`
  width: 100%;
  background: #fef3c7;
  border: 1px solid #fde68a;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #fde68a;
  }

  & span {
    font-size: 16px;
    font-weight: 400;
    color: #000;
    display: block;
    text-align: center;
  }

  ${({ disabled }) =>
    disabled
      ? css`
          color: black;
          cursor: not-allowed !important;
          background: ${palette('gray', 0)} !important;
          border: none !important;
        `
      : css``}
`;
